module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_8.59ed621c.png";